import './assets/styles/styles.pcss';

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createHead } from '@vueuse/head';

import VueLazyLoad from 'vue3-lazyload';
import Vue3SocialSharingPlugin from 'vue3-social-sharing';
import VueDeviceDetect from '@basitcodeenv/vue3-device-detect';
import { featureFlags } from '@lib/feature.flags';
import App from './App.vue';
import router from './router/router';
import i18n from './locales/i18n';
import VueEasyLightbox from 'vue-easy-lightbox';

import * as Sentry from '@sentry/vue';

// Import Mux player styles
import 'player.style/microvideo';

const app = createApp(App);
const head = createHead();

if (featureFlags.sentry) {
  Sentry.init({
    app,
    dsn: 'https://a26238b0b11041b9b2192b07cb8728f4@o613414.ingest.us.sentry.io/4509248700088320',
    environment: import.meta.env.VITE_ENV,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    // ignoreErrors: [
    //   '[mux-player 1.5.0]',
    //   'ip2c',
    //   '__gCrWeb.instantSearch',
    //   'Authorization will not be covered by the wildcard symbol (*)',
    // ],
  });
}

app.use(head);
app.use(VueLazyLoad, {
  // options...
});
app.use(VueDeviceDetect);
app.use(Vue3SocialSharingPlugin);
app.use(createPinia());
app.use(router);
app.use(i18n);
app.use(VueEasyLightbox);

app.mount('#app');
